"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupStyle = void 0;
var helios_styles_1 = require("@carvana/helios-styles");
var boxShadow = function (dropShadow) {
    return dropShadow.map(function (ds) { return "".concat(ds.x, "px ").concat(ds.y, "px ").concat(ds.blur, "px ").concat(ds.spread, "px ").concat(ds.color); })
        .join(', ');
};
exports.PopupStyle = {
    position: 'fixed',
    overflow: 'visible',
    top: '0px',
    left: '0px',
    zIndex: '10000001',
    background: "".concat(helios_styles_1.background.default),
    borderRadius: "".concat(helios_styles_1.borderRadius.md),
    boxShadow: "".concat(boxShadow(helios_styles_1.shadow.default)),
    color: "".concat(helios_styles_1.text.default),
    display: 'inline-flex',
    padding: "".concat(helios_styles_1.spacing['2Xl']),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    fontFamily: "".concat(helios_styles_1.body.regular.sm.fontFamily),
    fontSize: "".concat(helios_styles_1.body.regular.sm.fontSize),
    fontWeight: "".concat(helios_styles_1.body.regular.sm.fontWeight),
    letterSpacing: "".concat(helios_styles_1.body.regular.sm.letterSpacing),
    lineHeight: "".concat(helios_styles_1.body.regular.sm.lineHeight),
};
